import { useMemo } from "react";

import { FETCH_MMM_SUMMARY } from "@gql/mmm-summary";
import { useNorthbeamQuery } from "@hooks/http";
import {
  type FetchMmmSummary,
  type FetchMmmSummaryVariables,
} from "@north-beam/nb-client-side";
import { useSelectedCycle } from "@pages/mmm/hooks/use-selected-cycle";

export const useMmmSummary = () => {
  const { selectedCycle } = useSelectedCycle();

  const { loading, data } = useNorthbeamQuery<
    FetchMmmSummary,
    FetchMmmSummaryVariables
  >(FETCH_MMM_SUMMARY, {
    variables: {
      cycleId: selectedCycle.id,
    },
  });

  const accuracyData = useMemo(
    () => data?.me?.mmm?.summary?.accuracyData.data ?? [],
    [data],
  );

  return { loading, accuracyData };
};
